import { Link } from "react-router-dom";
import { photoUrl } from "@/lib/api";

const when = (iso) => {
  const d = new Date(iso);
  return d.toDateString() === new Date().toDateString()
    ? d.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })
    : d.toLocaleDateString("it-IT", { day: "numeric", month: "short" });
};

export const Avatar = ({ person, size = "w-11 h-11" }) => (
  <div className={`${size} bg-[#181B20] overflow-hidden shrink-0 flex items-center justify-center font-serif text-lg text-neutral-500`}>
    {person.photo ? <img src={photoUrl(person.photo)} alt="" className="w-full h-full object-cover" /> : person.name?.[0]}
  </div>
);

export const ConversationList = ({ list, activeId, meId }) => (
  <div className="divide-y divide-white/5" data-testid="conversation-list">
    {list?.length === 0 && (
      <p className="p-8 text-sm text-neutral-500 text-center" data-testid="conversation-list-empty">
        Nessuna conversazione. Le chat si aprono quando un cliente sblocca i contatti di una hostess.
      </p>
    )}
    {(list || []).map((c) => (
      <Link key={c.id} to={`/messaggi/${c.id}`} data-testid={`conversation-item-${c.id}`}
        className={`flex items-center gap-3 px-4 py-4 transition-colors ${c.id === activeId ? "bg-[#D4AF37]/10" : "hover:bg-white/[0.03]"}`}>
        <Avatar person={c.other} />
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2">
            <p className={`truncate ${c.unread ? "text-white font-semibold" : "text-neutral-200"}`}>{c.other.name}</p>
            <span className="text-[10px] font-mono text-neutral-500 shrink-0">{c.last_message ? when(c.last_at) : ""}</span>
          </div>
          <div className="flex items-center justify-between gap-2 mt-0.5">
            <p className="text-xs text-neutral-500 truncate">
              {c.last_message ? `${c.last_sender_id === meId ? "Tu: " : ""}${c.last_message}` : "Inizia la conversazione"}
            </p>
            {c.unread > 0 && <span className="min-w-[18px] h-[18px] px-1 bg-[#D4AF37] text-[#0B0C0E] text-[10px] font-bold flex items-center justify-center rounded-full" data-testid={`conversation-unread-${c.id}`}>{c.unread}</span>}
          </div>
        </div>
      </Link>
    ))}
  </div>
);
